import React from "react"

export interface CashTicketsProps {
  cashTicketsPurchased?: number | null
  cashTicketsTotal?: number | null
  onAddCashTicket: () => void
  onResetCashTicketCount?: () => void
  isResetting?: boolean
}

export const CashTickets: React.FC<CashTicketsProps> = ({
  cashTicketsPurchased,
  cashTicketsTotal,
  onAddCashTicket,
  onResetCashTicketCount,
  isResetting = false,
}) => {
  const hasCashTickets =
    cashTicketsPurchased != null || cashTicketsTotal != null

  return (
    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 flex flex-col justify-between">
      <div className="flex flex-wrap justify-between items-center gap-2 mb-3">
        <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wider">
          Cash Tickets
        </h3>
        <div className="flex items-center gap-2">
          {hasCashTickets && onResetCashTicketCount && (
            <button
              type="button"
              onClick={() => {
                if (
                  window.confirm(
                    "Are you sure you want to reset the cash ticket count to 0?",
                  )
                ) {
                  onResetCashTicketCount()
                }
              }}
              disabled={isResetting}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded hover:bg-gray-300 focus:outline-none disabled:opacity-50"
            >
              {isResetting ? "Resetting…" : "Reset Cash Ticket Count"}
            </button>
          )}
          <button
            type="button"
            onClick={onAddCashTicket}
            className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded hover:bg-green-700 focus:outline-none"
          >
            Add Cash Ticket
          </button>
        </div>
      </div>
      {hasCashTickets ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
          {cashTicketsPurchased != null && (
            <div>
              <span className="text-gray-600">Quantity:</span>
              <div className="font-medium text-black-800">
                {Number(cashTicketsPurchased)}
              </div>
            </div>
          )}
          {cashTicketsTotal != null && (
            <div>
              <span className="text-gray-600">Total:</span>
              <div className="font-medium text-black-800">
                ${Number(cashTicketsTotal)}
              </div>
            </div>
          )}
        </div>
      ) : (
        <p className="text-sm text-gray-500 italic">
          No cash tickets recorded yet
        </p>
      )}
      <div className="italic mt-4 text-gray-500 text-xs">
        Cash tickets are purely informational for your reference and do not
        affect your payout or any other stat calculations.
      </div>
    </div>
  )
}
